
const MessageGalleryItem = (props)=> {
    let newsDate = new Date(props.data.MODNewsPublishDate);
    return(
        <div className="col-12 col-md-4 MessageGalleryItem" key={"NewsLink_"+props.index}>
            <div className="LinkItem ">
                <a href={props.moreLink +"?itemId="+ props.data.ID} title="להודעה">
                    <div className="LinkTitle">
                        <p className="newsTitle">{props.data.Title}</p> 
                        <div className="dayHour">
                            <div className="date">{newsDate.toLocaleDateString('he-IL')}</div>
                            <div className="hour"><span>{String(newsDate.getHours()).padStart(2,'0')+":"+String(newsDate.getMinutes()).padStart(2,'0')} </span></div>
                        </div>
                    </div>  
                </a>
                <div className="yellowCorner"></div>
            </div>
        </div>
    )
}
export default MessageGalleryItem;

